function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .svg-door {\n                fill: #fff\n            }\n\n            .svg-door2 {\n                fill: none;\n                stroke: #fff;\n                stroke-miterlimit: 10;\n                stroke-width: 1.33px\n            }\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons_Top_copy",
  "data-name": "Icons Top copy"
}, /*#__PURE__*/React.createElement("polyline", {
  className: "svg-door2",
  points: "18.06 0.66 31.88 0.66 31.88 27.22 18.06 27.22"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-door",
  d: "M0,13.94a.67.67,0,0,0,.68.68H20.07a.68.68,0,0,0,0-1.35H.68A.67.67,0,0,0,0,13.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-door",
  d: "M13.08,20.25a.68.68,0,0,0,1.15.48l6.32-6.31a.68.68,0,0,0-1-1l-6.31,6.32A.67.67,0,0,0,13.08,20.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-door",
  d: "M13.08,7.63a.69.69,0,0,0,.2.48l6.31,6.31a.68.68,0,1,0,1-1L14.23,7.15a.68.68,0,0,0-1,0A.71.71,0,0,0,13.08,7.63Z"
})));

var SvgDoor = function SvgDoor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32.55 27.88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/door.709aa330.svg";
export { ForwardRef as ReactComponent };